//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import add from './add'
import resPush from './res-push'

export default {
    components: {add, resPush},
    props: [],
    data () {
        return {
            tableData: [],

			nodeBodyLength: 1,

			layDialogVisible: false,//弹窗控制器
            formUrl: 0,//弹窗文件路径er
			formTitle: '',

			iskeyword: '',

            search: {}
        }
    },
    computed: {

    },
    watch:{
		layDialogVisible: function(n, o){
			if(!n){
				this.queryData();
			};
		}
    },
	methods:{
		nodeBodyLengthChange: function(e){
			if(e > this.tableData.length){
				this.tableData.push.apply(this.tableData, Array.apply(null, Array(e - this.tableData.length)).map(function(item){return []}))
			}else {
				this.tableData.splice(e, (this.tableData.length - e))
			}
		},
		newNode: function (node, type){
			var code = '';
			if(type===-1){
				code += (Number(node.code) - 0.5);
			}else if(type===0){
				code += Number(node.code);
			}else if(type===1){
				code += (Number(node.code) + 0.5);
			}

            this.search = {
                rowguid: '',
                code: code,
                nodeguid: this.getQuery('nodeguid'),
                iskeyword: this.iskeyword
            };
            this.formUrl = 0;
			this.formTitle = '新建审核流程';
			this.layDialogVisible = true;
		},
		editNode: function (node){
			this.search = {
				rowguid: node.rowguid,
				code: node.code,
				nodeguid: this.getQuery('nodeguid'),
				iskeyword: this.iskeyword
			};
            this.formUrl = 0;
			this.formTitle = '编辑审核流程';
			this.layDialogVisible = true;
		},
		delNode: function(node){
			this.$post(this.getStore('sysUrl') + '/node/settingdel', {
				rowguid: node.rowguid
			}, function(data){
				this.queryData();
			})
		},
		queryData: function (){
			var that = this;
			this.$get(this.getStore('sysUrl') + '/node/settinglist', {
				nodeguid: this.getQuery('nodeguid')
			}, function(data){
				var dataArr = [];
                Object.keys(data.settinglist).forEach(function(item){
                    dataArr.push(data.settinglist[item]);
                });
				if(!dataArr.length){
					dataArr.push([{code:0}])
				}
                this.tableData = dataArr;
				this.iskeyword = data.iskeyword;
			})
		},

		editResPush: function() {
			var search = toSearch({
				nodeguid: this.getQuery('nodeguid')
			});
            this.formUrl = 1;
			// this.formUrl = './res-push-add.html' + search;
			this.formTitle = '编辑审核推送人';
			this.layDialogVisible = true;
		}
	},
	mounted:function(){
		this.queryData();
	}
}
